import React from 'react'
import PropTypes from 'prop-types';

export default function LoginFooter({ text, className }) {
    return (
        <div className="container">
            <div className={className} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    )
}

LoginFooter.propTypes = {
    text: PropTypes.any,
    className: PropTypes.any
};